module.exports = __webpack_public_path__ + "img/20191024172302360截图20191024162230992.6f92f71f.jpg";